import React from 'react';
import { makeStyles } from '@mui/styles';
import { MarketActionCard, MarketRow } from '@market/react';
import { shopImageSrcSet } from 'utilities/images';

export const CARD_ORIENTATIONS = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

const useStyles = makeStyles({
  horizontalRow: {
    '&::part(main)': {
      whiteSpace: 'pre-wrap',
    },
    '&::part(side)': {
      minWidth: 'fit-content',
    },
  },
  verticalRow: {
    height: '100%',
    '&::part(container)': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    '&::part(main)': {
      marginBottom: '1em',
    },
  },
});

const ProductActionCard = ({
  accessory,
  clickable = true,
  image,
  label,
  subtext,
  secondaryLabel,
  secondarySubtext,
  orientation = CARD_ORIENTATIONS.HORIZONTAL,
  value,
}) => {
  const classes = useStyles();

  return (
    <MarketActionCard
      value={value}
      {...(clickable
        ? {}
        : {
            style: {
              pointerEvents: 'none',
            },
          })}
    >
      {orientation === CARD_ORIENTATIONS.HORIZONTAL && (
        <MarketRow className={classes.horizontalRow}>
          {accessory}
          <label slot="label">{label}</label>
          {subtext && (
            <p slot="subtext" className="paragraph-20">
              {subtext}
            </p>
          )}
          {secondaryLabel && <label slot="side-label">{secondaryLabel}</label>}
          {secondarySubtext && (
            <p slot="side-subtext" className="paragraph-20">
              {secondarySubtext}
            </p>
          )}
        </MarketRow>
      )}

      {orientation === CARD_ORIENTATIONS.VERTICAL && (
        <MarketRow className={classes.verticalRow}>
          <img
            slot="leading-accessory"
            alt={label}
            srcSet={shopImageSrcSet({
              baseUrl: image,
              type: 'productModal',
            })}
            width="100%"
          />
          <label slot="label">{label}</label>
          {subtext && (
            <p slot="subtext" className="paragraph-20">
              {subtext}
            </p>
          )}
          {secondaryLabel && (
            <label slot="side-label" className="medium-30">
              {secondaryLabel}
            </label>
          )}
        </MarketRow>
      )}
    </MarketActionCard>
  );
};

export default ProductActionCard;
